const LOUVER_KIND_FROM_REFERENCE = {
    louver: 'impactLouver',
    'impact louver': 'impactLouver',
    'impact louver h': 'impactLouver',
    'impact louver v': 'impactLouver',
    'blank off panel': 'blankOffPanel',
    'back pan': 'backPan',
    'sill pan': 'sillPan',
    mesh: 'birdScreen',
    'bird screen': 'birdScreen',
    freight: 'freight',
    'export tariff': 'exportTariff',
    exporttariff: 'exportTariff',
}

export function costKindFromReference(reference) {
    if (reference == null || reference === '') return null
    return (
        LOUVER_KIND_FROM_REFERENCE[String(reference).toLowerCase().trim()] ||
        null
    )
}

export function costKind(cost) {
    if (!cost) return null
    if (cost.kind) return cost.kind
    return costKindFromReference(cost.reference || cost.name)
}
